export const COLOR_PRIMARY = "#44a659";
export const COLOR_SECONDARY = "#69a644";

export const COLOR_BLACK = "#000000";
export const COLOR_WHITE = "#ffffff";

export const COLOR_GRAY_300 = "#D1D5DB";
export const COLOR_GREEN_600 = "#059669";
